import { combineReducers } from "redux";
import { handleCreateInterviewInitialState } from "./reducers";

export let rootReducer = combineReducers({handleCreateInterviewInitialState});